/**
 * 大宗交易免责声明
 * 勾选大宗交易权限项提交时展示
 */
import './index.less';

import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';
import { FC } from 'react';

import { ConfirmModal } from '@/components/ConfirmModal';
import { useI18nContext } from '@/i18n/I18n';

interface IDisclaimerModal {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DisclaimerModal: FC<IDisclaimerModal> = (props) => {
  const { visible, onConfirm, onCancel } = props;
  const [$t] = useI18nContext();

  const goTerms = () => {
    const url = '/en/help-center/bybitHC_Article?language=en_US&id=000001702';
    // window.location.href = url;
    window.open(url);
  };

  const content = () => {
    const arr = $t('paradigmNoticeContent')
      .split(/[{}]/)
      .map((s, i) =>
        s === 'link' ? (
          <Button key={i} type="link" onClick={goTerms}>
            {$t('paradigmTerms')}
          </Button>
        ) : (
          s
        ),
      );
    return arr;
  };

  const renderContent = () => {
    return (
      <div className="disclaimerContent">
        <div className="iconContainer">
          <ExclamationCircleFilled />
        </div>
        <div className="title">{$t('Notice')}</div>
        <div className="content">{content()}</div>
      </div>
    );
  };
  return (
    <ConfirmModal
      isVisible={visible}
      content={renderContent()}
      onCancel={onCancel}
      onConfirm={onConfirm}
      okBtnText={$t('agree')}
      cancelBtnText={$t('reject')}
      showCancelBtn={true}
    />
  );
};
